import type { AssociatedProgram } from "@/features/site-chrome/model/siteChrome.types";
import { staticAssociatePrograms } from "./StaticAssociatePrograms";

/**
 * Associated programs of the page currently mounted (e.g. a Program Details
 * page passes only its own program, so the list has length 1). Published by
 * StickyWidget and read by the global CommonModals 30-sec popup, which lives
 * in the layout and has no access to page props.
 */
let pageAssociatedPrograms: AssociatedProgram[] = [];

export const setPageAssociatedPrograms = (programs: AssociatedProgram[] = []) => {
  pageAssociatedPrograms = programs;
};

export const getPageAssociatedPrograms = (): AssociatedProgram[] =>
  pageAssociatedPrograms.length ? pageAssociatedPrograms : staticAssociatePrograms;
